import { Button, Col, Descriptions, Row, Space, Table, Tag } from 'antd';
import styled from 'styled-components';
import { styledDescriptions, styledTable } from '../styled/mixin';
import Link from 'antd/lib/typography/Link';
import {
  corporateNumberFormatter,
  openKisconPage,
  phoneFormatter,
  priceToString,
} from '../../util/utils';
import { EnterpriseType1, enterpriseType1Korean } from '../../modules/auth';
import Title from 'antd/lib/typography/Title';
import { Vendor } from '../../modules/vendors';
import { ColumnsType } from 'antd/lib/table';
import { Invoice } from '../../modules/invoices';

interface VendorCompanyDetailComponentProps {
  vendor: Vendor;
  downloadFile: (attachFileId: string, fileName: string) => void;
  moveToEditPage?: () => void;
}

const StyledDiv = styled.div`
  ${styledDescriptions}
  ${styledTable}
`;

function VendorCompanyDetailComponent({
  vendor,
  downloadFile,
  moveToEditPage,
}: VendorCompanyDetailComponentProps) {
  const attachedFileList = vendor.attachedFiles.map((file: any) => (
    <li key={file.id}>
      <Link
        onClick={(e) => {
          e.stopPropagation();
          downloadFile(file.id, file.name);
        }}
      >
        {file.name}
      </Link>
    </li>
  ));

  const columns: ColumnsType<any> = [
    {
      title: '참여공사',
      width: '50%',
      children: [
        {
          title: '이름',
          width: '15%',
          align: 'left',
          ellipsis: true,
          render: (_, record: any) => `${record.project.name}`,
        },
        {
          title: '종료일',
          width: '10%',
          align: 'center',
          sorter: (a: Invoice, b: Invoice) =>
            a.project.endDate.localeCompare(b.project.endDate),
          render: (_, record: any) => `${record.project.endDate}`,
        },
        {
          title: '종류',
          width: '10%',
          dataIndex: ['project', 'type'],
          ellipsis: true,
          align: 'left',
        },
        {
          title: '면적(m²)',
          width: '8%',
          dataIndex: ['project', 'area'],
          align: 'right',
        },
      ],
    },

    // {
    //   title: '참여공사 기간',
    //   // dataIndex: ['project', 'name'],
    //   align: 'center',
    //   render: (_, record: any) =>
    //     `${record.project.name} (${record.project.startDate}~${record.project.endDate})`,
    // },
    // {
    //   title: '시작일',
    //   dataIndex: ['project', 'startDate'],
    //   align: 'center',
    // },
    // {
    //   title: '종료일',
    //   dataIndex: ['project', 'endDate'],
    //   align: 'center',
    // },
    // {
    //   title: '종류',
    //   dataIndex: ['project', 'type'],
    //   align: 'center',
    // },
    // {
    //   title: '상태',
    //   dataIndex: ['project', 'status'],
    //   align: 'center',
    //   render: (_, record: any) =>
    //     projectStatusKorean[record.project.status as ProjectStatus],
    // },
    {
      title: '공종',
      dataIndex: 'gongjong',
      align: 'center',
      width: '12%',
    },
    {
      title: '금액(원)',
      width: '18%',
      align: 'right',
      render: (_, record: any) => priceToString(record.price - record.vat),
    },
    {
      title: '총면적당 금액(원)',
      width: '18%',
      align: 'right',
      render: (_, record: any) =>
        record.project.area
          ? priceToString((record.price - record.vat) / record.project.area)
          : null,
    },
  ];

  console.log(vendor);

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={3}>사업자 상세</Title>
        </Col>
        {moveToEditPage && (
          <Space>
            <Col>
              <Button
                size="small"
                onClick={() =>
                  openKisconPage(
                    vendor.application.general.name,
                    vendor.application.general.representativeName,
                  )
                }
              >
                키스콘 상세정보 열기
              </Button>
            </Col>

            {moveToEditPage && (
              <Col>
                <Button size="small" onClick={moveToEditPage}>
                  수정하기
                </Button>
              </Col>
            )}
          </Space>
        )}
      </Row>
      <Descriptions
        // title="회사정보"
        bordered
        column={2}
        size="small"
        // style={{ marginTop: '10px' }}
        // extra={
        //   <Space>
        //     <Button
        //       size="small"
        //       onClick={() =>
        //         openKisconPage(
        //           vendor.application.general.name,
        //           vendor.application.general.representativeName,
        //         )
        //       }
        //     >
        //       키스콘 상세정보 열기
        //     </Button>
        //     {moveToEditPage && (
        //       <Button size="small" onClick={moveToEditPage}>
        //         수정하기
        //       </Button>
        //     )}
        //   </Space>
        // }
      >
        <Descriptions.Item label="회사명">
          {vendor.application.general.name}
        </Descriptions.Item>
        <Descriptions.Item label="대표명">
          {vendor.application.general.representativeName}
        </Descriptions.Item>

        <Descriptions.Item label="회사주소">
          {vendor.application.general.companyAddress}
        </Descriptions.Item>
        <Descriptions.Item label="홈페이지">
          <Link
            href={`${vendor.application.general.companyWebSite}`}
            target="_blank"
          >
            {vendor.application.general.companyWebSite}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="회사전화번호">
          {vendor.application.general.corporatePhoneNumber === undefined
            ? null
            : phoneFormatter(
                vendor.application.general.corporatePhoneNumber,
                1,
              )}
        </Descriptions.Item>
        <Descriptions.Item label="팩스번호">
          {vendor.application.general.companyFaxNumber === undefined
            ? null
            : phoneFormatter(vendor.application.general.companyFaxNumber, 1)}
        </Descriptions.Item>
        <Descriptions.Item label="사업자등록번호">
          {vendor.application.general.corporateNumber === undefined
            ? null
            : corporateNumberFormatter(
                vendor.application.general.corporateNumber,
              )}
        </Descriptions.Item>

        <Descriptions.Item label="종류">
          {vendor.application.general.type1 === undefined
            ? null
            : enterpriseType1Korean[
                vendor.application.general.type1 as EnterpriseType1
              ]}
        </Descriptions.Item>

        <Descriptions.Item label="보유면허">
          <>
            {vendor.application.general.type2 === undefined
              ? null
              : vendor.application.general.type2.map((tag: any, index: any) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
          </>
        </Descriptions.Item>
        <Descriptions.Item label="주력공종">
          {vendor.application.general.type3 === undefined
            ? null
            : vendor.application.general.type3.map((tag: any, index: any) => (
                <Tag key={index}>{tag}</Tag>
              ))}
        </Descriptions.Item>
        {/* <Descriptions.Item label="시공능력평가액">
          {vendor.application.general.sipyeongAmount === undefined
            ? null
            : priceToString(vendor.application.general.sipyeongAmount)}
        </Descriptions.Item>
        <Descriptions.Item label="신용등급">
          {vendor.application.general.creditRating}
        </Descriptions.Item>
        <Descriptions.Item label="매출액">
          {vendor.application.general.revenue === undefined
            ? null
            : priceToString(vendor.application.general.revenue)}
        </Descriptions.Item> */}

        <Descriptions.Item label="은행명">
          {vendor.application.accountInfo.bankName}
        </Descriptions.Item>
        <Descriptions.Item label="예금주">
          {vendor.application.accountInfo.accountHolder}
        </Descriptions.Item>
        <Descriptions.Item label="계좌번호">
          {vendor.application.accountInfo.accountNumber}
        </Descriptions.Item>

        <Descriptions.Item label="담당자 이름">
          {vendor.application.contactPoint.name}
        </Descriptions.Item>
        <Descriptions.Item label="담당자 이메일">
          {vendor.application.contactPoint.email}
        </Descriptions.Item>
        <Descriptions.Item label="담당자 휴대전화번호">
          {vendor.application.contactPoint.personalPhoneNumber === undefined
            ? null
            : phoneFormatter(
                vendor.application.contactPoint.personalPhoneNumber,
                1,
              )}
        </Descriptions.Item>
        <Descriptions.Item label="첨부파일">
          <>{attachedFileList}</>
        </Descriptions.Item>
      </Descriptions>
      <Row style={{ marginTop: '20px' }}>
        <Col>
          <Title level={4}>공사실적</Title>
        </Col>
      </Row>
      <Row justify="space-between">
        <Col span={24}>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={vendor.invoices}
            bordered
            summary={(pageData) => {
              let totalValue = 0;

              pageData.forEach(({ price, vat }) => {
                totalValue += price - vat;
              });

              return (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}></Table.Summary.Cell>
                    <Table.Summary.Cell index={1}></Table.Summary.Cell>
                    <Table.Summary.Cell index={2}></Table.Summary.Cell>
                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                    <Table.Summary.Cell index={4} align="center">
                      Total
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5} align="right">
                      {priceToString(totalValue)}
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                </>
              );
            }}
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
              position: ['bottomCenter'],
            }}
            locale={{
              triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
              triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
              cancelSort: '정렬을 취소하려면 클릭하세요.',
            }}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default VendorCompanyDetailComponent;
